var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfLink = function SvgHalfLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M13.657 13.657A8 8 0 0 0 2.343 2.343z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2DA0FC",
    d: "M2.343 2.343a8 8 0 0 0 11.314 11.314z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.312 7.307 8.686 8.68h1.097v1.18c0 .608.592.828 1.079.458l2.467-1.85a.57.57 0 0 0 0-.933l-2.468-1.86c-.468-.351-1.078-.167-1.078.459v1.172z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.123 7.307c-.389 0-.698.3-.698.678 0 .387.31.696.698.696h3.679L5.427 7.307z"
  })));
};
export default SvgHalfLink;